/**
 * Latori: exceptions to the setting "Open external links in a new tab".
 *
 * With that setting, main.js sets target="_blank" on every clicked link to a
 * different host. These links must stay in the same tab:
 * - new customer accounts (login and account) on shopify.com,
 * - mailto: and tel: links, which otherwise open an empty tab.
 *
 * main.js listens in the bubble phase on `document`. A bubble listener on
 * `window` always runs after it, so it can remove the target again before the
 * browser follows the link. Done here so the vendor file stays untouched.
 */
window.addEventListener('click', (evt) => {
  const link = evt.target instanceof Element ? evt.target.closest('a[href]') : null;
  // SVG <a> elements match too, but their href is not a string.
  if (!(link instanceof HTMLAnchorElement)) return;

  if (link.hostname === 'shopify.com' || (link.protocol !== 'http:' && link.protocol !== 'https:')) {
    link.removeAttribute('target');
  }
});
